module.exports = __webpack_public_path__ + "img/icon-play.0635206c.png";